import type { StyleSystemProps } from '@withjoy/joykit';
import { TextV2, Flex, Box, styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledCashFundCollectionMembersWrapper = styled(Box)``;
const cashFundCollectionMembersWrapperStyles: StyleSystemProps = {
  borderColor: 'mono3',
  borderStyle: 'solid',
  borderLeftWidth: ['0', '1px'],
  borderTopWidth: ['1px', '0'],
  borderBottomWidth: '0',
  borderRightWidth: '0',
  paddingLeft: [6, 6],
  paddingRight: [6, 0],
  flex: ['unset', '1 1 50%'],
  marginBottom: [0, 6],
  paddingTop: [5, 0],
  overflowY: ['unset', 'scroll'],
  marginX: [-6, 0],
};

export const StyledCashFundCollectionMembersTitle = styled(TextV2)``;
const cashFundCollectionMembersTitleStyles: StyleSystemProps = {
  paddingTop: [0, 4],
  textAlign: ['center', 'unset'],
};

export const StyledCollectionMemberContainer = styled(Flex)``;
const collectionMemberContainerStyles: StyleSystemProps = {
  paddingY: 5,
  borderBottom: '1px solid',
  borderColor: 'mono3',
  _hover: {
    cursor: 'pointer',
  },
  _last: {
    borderBottom: 'none',
  },
};

export const StyledCollectionMemberPhoto = styled(Box)``;
const collectionMemberPhotoStyles: StyleSystemProps = {
  flex: `1 0 ${pxToRem(100)}`,
  height: pxToRem(100),
  width: pxToRem(100),
  borderRadius: 2,
  backgroundColor: 'mono4',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
};

export const StyledCollectionMemberInfo = styled(Flex)``;
const collectionMemberInfoStyles: StyleSystemProps = {
  flex: '1 1 100%',
  height: pxToRem(100),
  justifyContent: 'center',
  flexDirection: 'column',
  paddingLeft: 5,
};

export const StyledCollectionItemTitle = styled(TextV2)`
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
`;
const collectionItemTitleStyles: StyleSystemProps = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  wordBreak: 'break-word',
  paddingY: 1,
};

export const styles = {
  collectionItemTitle: collectionItemTitleStyles,
  cashFundCollectionMembersTitle: cashFundCollectionMembersTitleStyles,
  collectionMemberContainer: collectionMemberContainerStyles,
  collectionMemberPhoto: collectionMemberPhotoStyles,
  collectionMemberInfo: collectionMemberInfoStyles,
  cashFundCollectionMembersWrapper: cashFundCollectionMembersWrapperStyles,
};
